import { jsx as _jsx } from "react/jsx-runtime";
import { ConnectedRouter } from 'connected-react-router';
import { Route, Switch } from 'react-router';
/*
    Override ConnectedRouter type as connected-react-router doesn't support PropsWithChildren
    https://ru.reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-typescript-definitions
    https://github.com/supasate/connected-react-router/issues/573
*/
const ConnectedRouterWithChildren = ConnectedRouter;
export const WrapWithRouterReduxContainer = (BaseComponent, { history }) => function RouterReduxWrapper(props) {
    return (_jsx(ConnectedRouterWithChildren, { history: history, children: _jsx(Switch, { children: _jsx(Route, { path: "/", render: () => _jsx(BaseComponent, { ...props }) }) }) }));
};
